import { render } from "./interventions.vue?vue&type=template&id=56087915&scoped=true"
import script from "./interventions.vue?vue&type=script&lang=js"
export * from "./interventions.vue?vue&type=script&lang=js"

import "./interventions.vue?vue&type=style&index=0&id=56087915&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56087915"]])

export default __exports__